export default "__VITE_ASSET__DWBdh3Ro__"